
    <form (ngSubmit)="saveHeadTab()" [formGroup]="form">
      <div class="ui-g form-group master-data">
        <div class="ui-g-12">
          <div [kv-form-element]="{ label: 'promotion.code', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="code"/>
          </div>
          <div [kv-form-element]="{ label: 'promotion.description', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="description"/>
          </div>
          <div [kv-form-element]="{ label: 'customerInfoSheet.startDate', md: '3'}">
            <p-calendar
              class="over"
              [showIcon]="true"
              formControlName="start_date"
              [readonlyInput]="false"
              [dateFormat]="calendarTranslate.dateFormat">
            </p-calendar>
          </div>
          <div [kv-form-element]="{ label: 'customerInfoSheet.endDate', md: '3'}">
            <p-calendar
              class="over"
              [showIcon]="true"
              formControlName="end_date"
              [readonlyInput]="false"
              [dateFormat]="calendarTranslate.dateFormat">
            </p-calendar>
          </div>
          <div [kv-form-element]="{ label: 'promotion.startRedemDate', md: '3'}">
          <p-calendar
            class="over"
            [showIcon]="true"
            formControlName="start_redem_date"
            [readonlyInput]="false"
            [dateFormat]="calendarTranslate.dateFormat">
          </p-calendar>
        </div>
        <div [kv-form-element]="{ label: 'promotion.endRedemDate', md: '3'}">
          <p-calendar
            class="over"
            [showIcon]="true"
            formControlName="end_redem_date"
            [readonlyInput]="false"
            [dateFormat]="calendarTranslate.dateFormat">
          </p-calendar>
        </div>
          <div [kv-form-element]="{ label: 'promotion.smallDescription', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="small_description"/>
          </div>
          <div [kv-form-element]="{ label: 'promotion.campaignType', md: '6' }">
            <p-dropdown
              [options]="campaignTypes"
              formControlName="campaign_type_id">
            </p-dropdown>
          </div>
          <div [kv-form-element]="{ label: '', md: '2' }"></div>
          <div [kv-form-element]="{ label: 'promotion.priority', md: '2' }">
            <input type="number" min="0" pInputText formControlName="priority" />
          </div>
          <div [kv-form-element]="{ label: '', md: '2' }"></div>
          <div [kv-form-element]="{ label: '', md: '2' }"></div>
          <div style="text-align: center" [kv-form-element]="{ label: 'promotion.pressureRules', md: '2' }">
            <p-inputSwitch formControlName="flag_pressure_rules"></p-inputSwitch>
          </div>
          <div [kv-form-element]="{ label: '', md: '2' }"></div>
        </div>
        <div class="ui-g-12 text-right">
          <button
            pButton
            type="submit"
            class="k-generic-btn"
            icon="fa fa-floppy-o"
            iconPos="left"
            label="{{ 'common.save' | translate }}"
            [disabled]="form.controls['start_date'].value > form.controls['end_date'].value ||
            form.controls['start_redem_date'].value > form.controls['end_redem_date'].value ||
            form.controls['start_date'].value === null ||
            form.controls['end_date'].value === null ||
            form.controls['start_redem_date'].value === null ||
            form.controls['end_redem_date'].value === null ||
            form.controls['code'].value === null ||
            form.controls['campaign_type_id'].value === null">
          </button>
        </div>
      </div>
    </form>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/components/tabs/head/tab-head.component.ts.TabHeadComponent.html